import React from "react";
import Modal from "../../../../../../_components/Modal";
import Text from "../../../../../../_components/Text";
import Button from "../../../../../../_components/Button";
import IconButton from "../../../../../../_components/IconButton";
import LoadingInput from "../../../../../../_components/LoadingInput";
import CurrencyInput from "react-currency-input";

import { CreateNFeContext } from "../../Context";
import { searchNCM, searchCFOP } from "../../../../../../api/products";
import { decimalFormat } from "../../../../../../utils";

export default (props) => {
  const [show, setShow] = React.useState(false);
  const [description, setDescription] = React.useState();
  const [quantity, setQuantity] = React.useState();
  const [price, setPrice] = React.useState();
  const [orderSaleNumber, setOrderSaleNumber] = React.useState();
  const [orderItemNumber, setOrderItemNumber] = React.useState();
  const [benefCode, setBenefCode] = React.useState();

  const [loading, setLoading] = React.useState(false);

  const [ncm, setNCM] = React.useState();
  const [NCMValid, setNCMValid] = React.useState(false);
  const [cfop, setCFOP] = React.useState();
  const [CFOPValid, setCFOPValid] = React.useState(false);

  const createNFeContext = React.useContext(CreateNFeContext);

  function onOpenModal() {
    setShow(true);
  }
  function onHide() {
    setShow(false);
  }

  function onSearchCFOP(code) {
    // lidar com 5.102
    code = code.replace(/\D+/g, "");
    setCFOP(code);
    toggleInvalid("remove", "cfop");
    setErrorText("cfop", "");
    if (code.length === 4) {
      setLoading(true);
      searchCFOP({ code })
        .then((resp) => {
          if (resp.length === 0) {
            toggleInvalid("add", "cfop");
            setErrorText("cfop", "CFOP não localizado");
            setCFOPValid(false);
          } else {
            setCFOPValid(true);
          }
        })
        .catch()
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
            setFocus("cfop");
          }, 1000);
        });
    }
  }

  function onSearchNCM(code) {
    code = code.replace(/\D+/g, "");
    setErrorText("ncm", "");
    setNCM(code);
    toggleInvalid("remove", "ncm");
    if (code.length === 8) {
      setLoading(true);
      searchNCM({ code })
        .then((resp) => {
          if (resp.length === 0) {
            toggleInvalid("add", "ncm");
            setErrorText("ncm", "NCM Não localizado");
            setNCMValid(false);
          } else {
            setNCMValid(true);
          }
        })
        .catch()
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
            setFocus("ncm");
          }, 1000);
        });
    }
  }

  function onSave() {
    const { nfe } = createNFeContext;
    nfe.items[props.item.index].description = description;
    nfe.items[props.item.index].sellable.name = description;

    const itemCurrentQuantity = nfe.items[props.item.index].quantity;
    const itemCurrentPrice = nfe.items[props.item.index].item_sale_price;
    let hasDiff = itemCurrentQuantity != quantity || itemCurrentPrice != price;
    if (hasDiff) {
      createNFeContext.handlers.setNFePayments([])
    }

    nfe.items[props.item.index].quantity = quantity;
    nfe.items[props.item.index].item_sale_price = price;

    const bc = decimalFormat(price * quantity);
    
    if(nfe.items[props.item.index].icms) {
      const p_icms = nfe.items[props.item.index].icms.p_icms;
      
      nfe.items[props.item.index].icms.bc_icms = bc;

      if(!["0", false, undefined].includes(p_icms)) {
        nfe.items[props.item.index].icms.v_icms = decimalFormat(bc * (p_icms / 100))
      }
    }

    if(nfe.items[props.item.index].ipi) {
      const p_ipi = nfe.items[props.item.index].ipi.p_ipi;
      
      nfe.items[props.item.index].ipi.bc_ipi = bc;

      if(!["0", false, undefined].includes(p_ipi)) {
        nfe.items[props.item.index].ipi.v_ipi = decimalFormat(bc * (p_ipi / 100))
      }
    }

    if(nfe.items[props.item.index].pis) {
      const p_pis = nfe.items[props.item.index].pis.p_pis;
      
      nfe.items[props.item.index].pis.bc_pis = bc;

      if(!["0", false, undefined].includes(p_pis)) {
        nfe.items[props.item.index].pis.v_pis = decimalFormat(bc * (p_pis / 100))
      }
    }

    if(nfe.items[props.item.index].cofins) {
      const p_cofins = nfe.items[props.item.index].cofins.p_cofins;
      
      nfe.items[props.item.index].cofins.bc_cofins = bc;

      if(!["0", false, undefined].includes(p_cofins)) {
        nfe.items[props.item.index].cofins.v_cofins = decimalFormat(bc * (p_cofins / 100))
      }
    }

    if (NCMValid) {
      nfe.items[props.item.index].ncm = ncm;
    }
    if (CFOPValid) {
      nfe.items[props.item.index].cfop_code = cfop;
      createNFeContext.handlers.validateCFOP();
    }

    nfe.items[props.item.index].order_sale_number = orderSaleNumber;
    nfe.items[props.item.index].order_item_number = orderItemNumber;
    nfe.items[props.item.index].benef_code = benefCode;

    createNFeContext.handlers.updateNFeData(nfe);

    onHide();
    if (CFOPValid) {
      createNFeContext.handlers.validateCFOP();
    }
    setTimeout(() => {
      createNFeContext.handlers.updateTotalNFe();
    }, 100);
  }

  function onShowModal() {
    if (show === true) {
      setDescription(props.item.sellable.name);
      setQuantity(props.item.quantity);
      setPrice(props.item.item_sale_price);

      setCFOP(props.item.cfop_code || props.item.cfop);

      setOrderSaleNumber(props.item.order_sale_number);
      setOrderItemNumber(props.item.order_item_number);
      setBenefCode(props.item.benef_code);

      if (props.setFocus) {
        setFocus(props.setFocus);
      }
      if (props.item.fiscal_data) {
        setNCM(props.item.ncm || props.item.fiscal_data.ncm.code);
      }
    }
  }
  function setFocus(name) {
    try {
      document.querySelector(`[name="${name}"]`).focus();
    } catch (error) {}
  }
  function toggleInvalid(action, name) {
    try {
      document
        .querySelector(`[name="${name}"]`)
        .classList[action]("is-invalid");
    } catch (error) {}
  }
  function setErrorText(name, text) {
    try {
      document.querySelector(
        `[data-span-data-error-description="${name}"]`
      ).textContent = text;
    } catch (error) {}
  }
  React.useEffect(onShowModal, [show]);

  return (
    <div title="Editar Detalhes do Item">
      <IconButton
        data-cy-test={`#open-update-item=${props.index}`}
        onClick={onOpenModal}
        icon="pencil-alt"
      />
      <Modal title="Editar Detalhes do Item" show={show} onHide={onHide}>
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">Descrição</Text>
                </div>
                <LoadingInput
                  data-cy-test={`#change-item-input-item-description=${props.index}`}
                  name="description"
                  maxLength={120}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">Quantidade</Text>
                </div>
                <CurrencyInput
                  data-cy-test={`#change-item-input-item-quantity=${props.index}`}
                  className="form-control"
                  decimalSeparator=","
                  thousandSeparator="."
                  precision="3"
                  value={quantity}
                  name="quantity"
                  onChange={(mask, value) => setQuantity(value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">Valor</Text>
                </div>
                <CurrencyInput
                  data-cy-test={`#change-item-input-item-price=${props.index}`}
                  className="form-control"
                  decimalSeparator=","
                  thousandSeparator="."
                  precision="2"
                  prefix="R$ "
                  name="price"
                  value={price}
                  onChange={(mask, value) => setPrice(value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-xs-4">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">Número do Pedido</Text>
                </div>
                <LoadingInput
                  placeholder="Valor Máx. 15 dígitos"
                  onChange={(e) => setOrderSaleNumber(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                  maxLength={15}
                  value={orderSaleNumber}
                />
              </div>
            </div>
            <div className="col-md-4 col-xs-4">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">Item do Pedido</Text>
                </div>
                <LoadingInput
                  placeholder="Valor Máx. 6 dígitos"
                  maxLength={6}
                  onChange={(e) => setOrderItemNumber(e.target.value)}
                  value={orderItemNumber}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-md-4 col-xs-4">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">Código de Benefício</Text>
                </div>
                <LoadingInput
                  placeholder="Valor Máx. 8 dígitos"
                  onChange={(e) => setBenefCode(e.target.value)}
                  value={benefCode}
                  maxLength={8}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-lg-4">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">NCM</Text>
                </div>
                <LoadingInput
                  loading={loading}
                  onChange={(e) => onSearchNCM(e.target.value)}
                  value={ncm}
                  maxLength={8}
                  name="ncm"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                />
                <Text
                  className="text-danger"
                  data-span-data-error-description="ncm"
                />
              </div>
            </div>
            <div className="col-md-4 col-lg-4">
              <div className="form-group">
                <div className="form-label">
                  <Text className="py-2">CFOP</Text>
                </div>
                <LoadingInput
                  name="cfop"
                  onChange={(e) => onSearchCFOP(e.target.value)}
                  value={cfop}
                  loading={loading}
                  maxLength={4}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      onSave();
                    }
                  }}
                />
                <Text
                  className="text-danger"
                  data-span-data-error-description="cfop"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-center">
                <Button
                  data-cy-test="#button-confirm-update-nfe-item"
                  onClick={onSave}
                >
                  Salvar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Items/ChangesItem/index.jsx